<template>
  <v-app>
    <!-- MENUS -->
    <MenuDesktop
      class="d-none d-lg-block"
      @changeTab="changeTab"
      @switchLocale="switchLocale"
      @career="careerFunc"
    />
    <MenuMobile
      class="d-lg-none"
      @openMenu="openMenu"
      @career="careerFunc"
    />

    <v-main class="ma-0 pa-0">
      <v-container fluid class="ma-0 pa-0">
        <!-- passa o estado ao componente das rotas (compat com RouterView) -->
        <router-view class="d-lg-none" :menuTab="menuTab" @change="changeTab" />
        <Career ref="careerRef" />

        <!-- Cookie bar -->
        <Cookie
          v-model:snackbar="showCookieBar"
          @cookie-accept="cookieAccept"
          @cookie-reject="cookieReject"
        />
      </v-container>
    </v-main>

    <!-- MENU MOBILE SLIDE-UP -->
      <v-expand-transition>
        <v-scroll-y-reverse-transition v-if="mobileMenuOpen" class="ma-0 pa-0">
          <v-container
            fluid
            style="position: fixed; bottom: 0; z-index: 100;"
            class="ma-0 pa-0"
          >
            <v-card class="text-white rounded-xl ma-0 pa-0">
              <v-container fluid class="primary text-uppercase font-weight-bold text-h6"  style="background: #0d1f2b  !important;">
                <span class="text-white">Menu</span>
                <v-btn style="float: right;background: transparent !important" text @click="mobileMenuOpen = false">
                  <v-icon x-large class="text-white font-weight-bold" style="background: transparent !important">mdi-close</v-icon>
                </v-btn>
              </v-container>

              <v-card-text class="primary text-uppercase font-weight-bold" style="background: #0d1f2b  !important;">
                <v-row>
                  <!-- Home -->
                  <v-col cols="12" >
                    <v-row no-gutters>
                      <v-col cols="6" class="d-flex justify-end align-end">
                        <div style="height: 30px; width: 30px; clip-path: polygon(0 9%, 0 90%, 100% 55%); background-color: #85A2AD;"></div>
                      </v-col>
                      <v-col cols="6" align="start" justify="start">
                        <v-btn text class="text-white elevation-0" style="background: transparent !important" @click="getHome">
                          {{ $t('menuv2.home') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!-- Utility -->
                  <v-col cols="12" class="text-left">
                    <v-row no-gutters justify="center">
                      <v-col cols="6" class="d-flex justify-end align-end">
                        <div style="height: 30px; width: 30px; clip-path: polygon(0 78%, 99% 81%, 55% 0); background-color: #1C3C42;"></div>
                      </v-col>
                      <v-col cols="6" align="start" justify="start">
                        <v-btn text class="text-white elevation-0" style="background: transparent !important" @click="push('home/utility')">
                          <div>{{ $t('menuv2.utility') }}</div>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!-- Portfolio -->
                  <v-col cols="12" class="text-left">
                    <v-row no-gutters justify="center">
                      <v-col cols="6" class="d-flex justify-end align-end">
                        <div style="height: 30px; width: 30px; clip-path: polygon(0 78%, 100% 96%, 69% 0); background-color: #C9D2DA;"></div>
                      </v-col>
                      <v-col cols="6" align="start" justify="start">
                        <v-btn text class="text-white elevation-0" style="background: transparent !important" @click="push('home/portfolio')">
                          {{ $t('menuv2.portfolio') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!-- Team -->
                  <v-col cols="12" class="text-left">
                    <v-row no-gutters justify="center">
                      <v-col cols="6" class="d-flex justify-end align-end">
                        <div style="height: 30px; width: 30px; clip-path: polygon(0 29%, 100% 87%, 100% 19%); background-color: #E98459;"></div>
                      </v-col>
                      <v-col cols="6" align="start" justify="start">
                        <v-btn text class="text-white elevation-0" style="background: transparent !important" @click="push('home/team2')">
                          {{ $t('menuv2.team') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!-- Technologies -->
                  <v-col cols="12" class="text-left">
                    <v-row no-gutters justify="center">
                      <v-col cols="6" class="d-flex justify-end align-end">
                        <div style="height: 30px; width: 30px; clip-path: polygon(100% 96%, 100% 4%, 31% 66%); background-color: #E76012;"></div>
                      </v-col>
                      <v-col cols="6" align="start" justify="start">
                        <v-btn text class="text-white elevation-0" style="background: transparent !important" @click="push('home/technologies')">
                          {{ $t('menuv2.technologies') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!-- FAQ -->
                  <v-col cols="12" class="text-left">
                    <v-row no-gutters justify="center">
                      <v-col cols="6" class="d-flex justify-end align-end">
                        <div style="height: 30px; width: 30px; clip-path: polygon(100% 96%, 100% 4%, 31% 66%); background-color: #E76012;"></div>
                      </v-col>
                      <v-col cols="6" align="start" justify="start">
                        <v-btn text class="text-white elevation-0" style="background: transparent !important" @click="push('home/faq')">
                          {{ $t('menuv2.faq') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!-- Contacts -->
                  <v-col cols="12" class="text-left">
                    <v-row no-gutters justify="center">
                      <v-col cols="6" class="d-flex justify-end align-end">
                        <div style="height: 30px; width: 30px; clip-path: polygon(96% 89%, 98% 8%, 6% 94%); background-color: #052947;"></div>
                      </v-col>
                      <v-col cols="6" align="start" justify="start">
                        <v-btn text class="text-white elevation-0" style="background: transparent !important" @click="push('contacts')">
                          {{ $t('menuv2.contacts') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!-- Blog -->
                  <v-col cols="12" class="text-left">
                    <v-row no-gutters justify="center">
                      <v-col cols="6" class="d-flex justify-end align-end">
                        <div style="height: 30px; width: 30px; clip-path: polygon(96% 89%, 12% 91%, 13% 27%); background-color: #7F8B9B;"></div>
                      </v-col>
                      <v-col cols="6" align="start" justify="start">
                        <v-btn text class="text-white elevation-0" style="background: transparent !important" @click="push('blog')">
                          {{ $t('menuv2.blog') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-container>
        </v-scroll-y-reverse-transition>
      </v-expand-transition>

    <v-footer padless fluid class="ma-0 pa-0" color="secondary" fill-height>
      <Footer />
    </v-footer>
  </v-app>
</template>

<script>
import Footer from '@/views/Footer.vue'
import MenuDesktop from '@/components/Desktop/Menu'
import Career from '@/views/Career'
import MenuMobile from '@/components/Mobile/Menu'
import Cookie from '@/components/cookies/Cookie.vue'

export default {
  name: 'Layout',
  components: { Footer, MenuDesktop, Career, MenuMobile, Cookie },
  data () {
    return {
      menuTab: '',
      mobileMenuOpen: false,
      viewport: { width: 0, height: 0 },
      showCookieBar: true,
      locales: (process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'pt').split(',')
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    const language = this.$route.params.lang
    if (typeof language === 'string' && language) this.$i18n.locale = language

    const cookie = this.$cookies.get('dreamdeal_cookie')
    if (cookie == null) this.showCookieBar = true

    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    menuTab (val) {
      if (!val) return
      if (this.$route.name === 'Blog') this.$router.push({ path: '/' })
      if (val === 'blog') {
        this.menuTab = val
        this.$router.push({ name: 'blog', params: { lang: this.$i18n.locale } })
        return
      }
      this.menuTab = val
    },
    '$route.params.lang' (lang) {
      if (typeof lang === 'string' && lang) this.$i18n.locale = lang
    }
  },
  methods: {
    // header + menu mobile
    handleResize () {
      this.viewport.width = window.innerWidth
      this.viewport.height = window.innerHeight
    },
    handleScroll () {
      // usado pelo MenuMobile (v-show no header)
      // não precisamos de estado aqui; apenas mantemos a assinatura
    },
    openMenu () { this.mobileMenuOpen = !this.mobileMenuOpen },

    // cookies
    cookieReject () {
      this.$cookies.set('dreamdeal_cookie', null, '1s')
      this.showCookieBar = false
    },
    cookieAccept (ob) {
      this.$cookies.set('dreamdeal_cookie', JSON.stringify(ob), '7d')
      this.showCookieBar = false
    },

    // navegação auxiliar
    getHome () {
      this.$router.push({ path: `/${this.$i18n.locale}` })
    },
    push (path) {
      const clean = String(path).replace(/^\//, '')
      this.$router.push({ path: `/${this.$i18n.locale}/${clean}` })
      this.mobileMenuOpen = false
    },

    // carreira (dialog)
    careerFunc () {
      this.$gtag?.event?.('career_click', {
        event_category: 'Carreira',
        event_label: 'Carreira',
        value: 'career'
      })
      this.$refs.careerRef?.openDialog?.()
    },

    // comunicação com menus
    changeTab (t) { this.menuTab = t },

    // idioma
    switchLocale () {
      const next = this.$i18n.locale === 'pt' ? 'en' : 'pt'
      this.$i18n.locale = next
      this.$router.push({ name: this.$route.name, params: { ...this.$route.params, lang: next } })
    },

    // util (usado por componentes filhos que esperem esta função)
    getVersion () {
      return process.env.VUE_APP_SECRET_VERSION
    }
  }
}
</script>

<style>
.menu-triangle {
  width: 0;
  height: 0;
  border: 10px solid transparent;
  rotate: -90deg;
}
</style>
